"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Allergens = void 0;
var React = require("react");
var state_1 = require("../compare/state");
var AllergenLevel_1 = require("../shared/constants/AllergenLevel");
var _ = require("lodash");
var Allergens = function () {
    var state = (0, state_1.useStateValue)().state;
    var products = state.products, allergens = state.allergens;
    var getAllergenSymbol = function (allergen) {
        var allergenSymbol = React.createElement("div", null);
        switch (allergen.allergenLevel) {
            case AllergenLevel_1.AllergenLevel.contains:
                allergenSymbol = React.createElement("div", { className: "circle" },
                    React.createElement("img", { src: "/images/Icons/circle-red.png", alt: "Red Circle" }));
                break;
            case AllergenLevel_1.AllergenLevel.mayContain:
            case AllergenLevel_1.AllergenLevel.freeFrom:
                allergenSymbol = React.createElement("div", { className: "circle" },
                    React.createElement("img", { src: "/images/Icons/circle-green.png", alt: "Green Circle" }));
                break;
        }
        return allergenSymbol;
    };
    var getAllergenValue = function (products, code) {
        var allergenValue = products.map(function (product) {
            var allergen = _.find(product.allergens, function (a) { return a.allergenCode === code; });
            return React.createElement("td", { key: product.arident, style: { width: "".concat(100 / products.length, "%") } }, getAllergenSymbol(allergen));
        });
        return allergenValue;
    };
    var getAllergenRows = function (products, allergens) {
        var allergenRows = allergens.filter(function (allergen) { return allergen.parentCode === null; }).map(function (allergen) {
            return React.createElement(React.Fragment, { key: allergen.code },
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 3 },
                        React.createElement("strong", null, allergen.name))),
                React.createElement("tr", null, getAllergenValue(products, allergen.code)));
        });
        return allergenRows;
    };
    var getMayContainText = function (products) {
        var mayContain = products.map(function (product) {
            return React.createElement("div", { className: "may-contain-column", key: product.arident }, getMayContainParagraph(product.mayContainText));
        });
        return mayContain;
    };
    var getMayContainParagraph = function (mayContainText) {
        var mayContainParagraph = mayContainText
            ? React.createElement("p", { className: "mayContainText" },
                "Produktet kan inneholde spor av:",
                React.createElement("span", { className: "bold" },
                    " ",
                    mayContainText))
            : null;
        return mayContainParagraph;
    };
    return (React.createElement("section", { className: "allergens" },
        React.createElement("h2", null, "Allergener"),
        React.createElement("table", { className: "table-allergen" },
            React.createElement("tbody", null, getAllergenRows(products, allergens))),
        React.createElement("div", { className: "may-contain-container" }, getMayContainText(products)),
        React.createElement("div", { id: "color-explanation", className: "row" },
            React.createElement("div", { className: "circle-explanation" },
                React.createElement("img", { src: "/images/Icons/circle-red.png", alt: "Red circle" }),
                React.createElement("span", null, "Ja = allergenet inng\u00E5r i produktet")),
            React.createElement("div", { className: "circle-explanation" },
                React.createElement("img", { src: "/images/Icons/circle-green.png", alt: "Green circle" }),
                React.createElement("span", null, "Nei = produktet inneholder ikke det angitte allergenet")))));
};
exports.Allergens = Allergens;
